interface ScrollOptions {
  offset?: number;
  delayMs?: number;
}

/**
 * Smoothly scrolls the viewport so that the target element (or selector) sits
 * near the top, accounting for a configurable offset. Used to keep filter
 * sections in view when Action Center items deep-link into a tab.
 */
export function scrollSectionIntoView(
  target: string | Element,
  { offset = 24, delayMs = 500 }: ScrollOptions = {},
) {
  const resolveElement = () => {
    if (typeof target === 'string') {
      return document.querySelector<HTMLElement>(target);
    }
    return target as HTMLElement | null;
  };

  requestAnimationFrame(() => {
    window.setTimeout(() => {
      const element = resolveElement();
      if (!element) return;

      const container = element.closest('.card') ?? element;
      const rect = container.getBoundingClientRect();
      const position = Math.max(window.pageYOffset + rect.top - offset, 0);
      window.scrollTo({ top: position, behavior: 'smooth' });
    }, delayMs);
  });
}



